import React from 'react';

import type { CareerCmsRecord } from './cms-provider/career-cms-provider';

export const CareerCmsContent = React.createContext<CareerCmsRecord>(null as never);
